import startCase from 'lodash/startCase'

export default (el, binding, vnode) => {
  el.innerHTML = startCase(el.innerHTML)
}
